export const getCurrentUserPermissions = (state) =>
  state.permissions.currentUserPermissions.data;
export const getRoles = (permissions) => permissions.userRoles.data;

export default {
  getCurrentUserPermissions,
  getRoles,
};
